import { Card } from "@caprikorn/dynamo-ui";
import { getFullAddress, getFullName } from "@caprikorn/dynamo-utils";
import type { FC } from "react";

import { CustomTrans } from "@utils/translations/CustomTrans";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./ShieldCertificateDisplay.module.css";
import type { ShieldCertificateDisplayProps } from "./ShieldCertificateDisplay.types";

export const ShieldCertificateDisplay: FC<ShieldCertificateDisplayProps> = ({
  certificate,
}) => {
  const { t } = useCustomTranslation("main");

  return (
    <Card className={classes.container}>
      {certificate?.signatureDate && (
        <p className="font-body-highlight">
          {t("shield.certificate.subtitle", {
            date: new Date(certificate.signatureDate),
          })}
        </p>
      )}
      <p>
        <span className="font-label-default">
          <CustomTrans
            components={{
              span: <span className="font-label-highlight" />,
            }}
            i18nKey="shield.certificate.siren"
            ns="main"
            values={{
              siren: certificate?.siren,
            }}
          />
        </span>
      </p>
      <p>
        <span className="font-label-default">
          <CustomTrans
            components={{
              span: <span className="font-label-highlight" />,
            }}
            i18nKey="shield.certificate.companyName"
            ns="main"
            values={{
              company: certificate?.company,
            }}
          />
        </span>
      </p>
      <p>
        <CustomTrans
          components={{
            span: <span className="font-label-highlight" />,
          }}
          i18nKey="shield.certificate.address"
          ns="main"
          values={{
            address: getFullAddress(certificate?.address),
          }}
        />
      </p>
      <p>
        <CustomTrans
          components={{
            span: <span className="font-label-highlight" />,
          }}
          i18nKey="shield.certificate.email"
          ns="main"
          values={{
            email: certificate?.mail,
          }}
        />
      </p>
      <p>
        <CustomTrans
          components={{
            span: <span className="font-label-highlight" />,
          }}
          i18nKey="shield.certificate.phoneNumber"
          ns="main"
          values={{
            phoneNumber: certificate?.phoneNumber,
          }}
        />
      </p>
      <p>
        <CustomTrans
          components={{
            span: <span className="font-label-highlight" />,
          }}
          i18nKey="shield.certificate.signatory"
          ns="main"
          values={{
            fullname: getFullName({
              firstName: certificate?.firstName,
              lastName: certificate?.name,
            }),
            signatory: certificate?.signatoryDescription,
          }}
        />
      </p>
      <p>
        <CustomTrans
          components={{
            span: <span className="font-label-highlight" />,
          }}
          i18nKey="shield.certificate.signatureLocation"
          ns="main"
          values={{
            signatureLocation: certificate?.signatureLocation,
          }}
        />
      </p>

      {certificate.statement && (
        <div className={classes.mention}>
          <p>
            {t(`shield.certificate.statement.${certificate.statement}.text1`)}
          </p>

          {certificate.statement === 3 && (
            <ul>
              <li>{t("shield.certificate.statement.3.appendix1")}</li>
              <li>{t("shield.certificate.statement.3.appendix2")}</li>
            </ul>
          )}

          <p className="font-body-accent">
            {t(`shield.certificate.statement.${certificate.statement}.text2`)}
          </p>
        </div>
      )}
    </Card>
  );
};
